import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap } from '../../components';
import { useParams } from 'react-router';
import WeeklyTaskForm from './WeeklyTaskForm';

export default function CreateWeeklyTaskScreen() {
  const { weekNumber, weekId } = useParams();

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Create Weekly Task"
          items={[
            {
              name: `Program Week ${weekNumber}`,
              url: `/program/${weekNumber}/${weekId}/weekly-tasks`,
            },
          ]}
        />
        <WeeklyTaskForm existing={undefined} />
      </Stack>
    </ScreenWrap>
  );
}
